import HistoricoConta from './HistoricoConta';

export default HistoricoConta;
